import classNames from 'classnames';
import React, { useRef, useEffect } from 'react';
import css from './ProtocolState.css';

const ProtocolState = (props) => {
  const { transaction, onUpdateTransactionOnly } = props;
  const { pickupSignKey, pickupSigned, deliverSignKey, returnSigned } = transaction?.attributes.protocol || {};
  const shouldPoll = !!((pickupSignKey && !pickupSigned) || (deliverSignKey && !returnSigned));

  useEffect(() => {
    let active = true;
  
    if (transaction && !shouldPoll) return;
  
    const poll = async () => {
      if (!active) return; // przerwij jeśli id się zmieniło lub komponent się odmontował
  
      try {
        await onUpdateTransactionOnly(transaction.id.uuid);
      } catch (e) {
        console.error('Błąd pobierania danych protokołu:');
      } finally {
        if (shouldPoll && active) {
          setTimeout(poll, 3000);
        }
      }
    };
  
    poll();
  
    return () => {
      active = false; // wyłącz polling przy unmount lub zmianie dependency
    };
  }, [transaction?.id.uuid, shouldPoll]);

  return (
    <div className={css.protocolStateContainer}>
      <div className={classNames(css.state)}>Protokół odbioru: {pickupSigned ? <span className={css.signed}>Podpisany</span> : <span className={classNames({ [css.notSigned]: transaction.attributes.processState === 'picked-up' ||  transaction.attributes.processState === 'delivered'})}>Niepodpisany</span>}</div>
      <div className={classNames(css.state, { [css.hidden]: transaction?.attributes.processState === 'accepted' })}>Protokół zwrotu: {returnSigned ? <span className={css.signed}>Podpisany</span> : <span className={classNames({ [css.notSigned]: transaction.attributes.processState === 'delivered' })}>Niepodpisany</span>}</div>
    </div>
  );
};

export default ProtocolState;
